module.exports = __webpack_public_path__ + "static/media/hackerrank.c2e392d4.svg";